import { observer } from "mobx-react";

import "./QuestionsReportModal.scss";

export const QuestionsReportModal = observer(({ report }) => {
  const questions = report.questions;
  return (
    <div className="report-modal__subplate">
      <h3>Проверочные вопросы</h3>
      {questions.length === 1
        ? questions[0]
        : questions.map((question, i) =>
          <p className="report-modal__question" key={1 + i}>
            {`Вопрос ${1 + i}: ${question}`}
          </p>
        )
      }
    </div>
  );
});
